import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-brand-cream px-4 py-5 sm:px-6" aria-labelledby="faq-heading" data-id="element-46" data-mp="1hcrxiameb0tt">
      <h2 id="faq-heading" className="mb-3 text-center font-heading text-xl uppercase leading-tight text-brand-navy sm:text-3xl" data-id="element-47" data-mp="1cf041c63r6ni">
        Questions fréquemment posées
      </h2>
      <div className="mx-auto max-w-xl space-y-1.5" data-id="element-48" data-mp="252macs6pspe2">
        {faqs.map((faq, index) => <article key={faq.question} className="overflow-hidden rounded-lg bg-white shadow-sm" data-id="element-49" data-mp="203swgynimwdd" data-mpi={index}>
            <button type="button" aria-expanded={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} className="flex w-full items-center justify-between gap-2 px-3 py-2.5 text-left hover:bg-brand-green/10 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-brand-green" data-id="element-50" data-mp="1v580xcj7l0v9">
              <span className="text-[11px] font-extrabold leading-snug text-brand-navy sm:text-xs" data-id="element-51" data-mp="1pmtcg6bi01v3">
                {faq.question}
              </span>
              <ChevronDownIcon className={`h-4 w-4 shrink-0 text-brand-green transition-transform ${openIndex === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-52" data-mp="1aor8vw4gvgdu" />
            </button>
            {openIndex === index && <p className="px-3 pb-2.5 text-[11px] font-medium leading-snug text-brand-ink/80 sm:text-xs" data-id="element-53" data-mp="16oh58q45d225">
                {faq.answer}
              </p>}
          </article>)}
      </div>
    </section>;
}